import React, { useState, useEffect } from 'react';
import axios from 'axios';

const LetsSee = () => {
  const [orders, setOrders] = useState([]);
  const [products, setProducts] = useState([]);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [couriers, setCouriers] = useState([]);
  const [staffMembers, setStaffMembers] = useState([]);
  const [formData, setFormData] = useState({
    customer_name: '',
    order_date: '',
    order_time: '',
    total_amount: '',
    original_total_amount: '',
  //  rate: '',
    // We'll use approval_status for the order status:
    approval_status: 'Pending',
    companyName: '',
    products: [], // ✅ Always initialize as an empty array
    shipping_address: '',
    // Use assigned_to instead of caller:
    assigned_to: '',
    courier: '',
    pin: '',
    mobile: '',
    so: '',
    village: '',
    city: '',
    district: '',
    state: '',
    quantity: '',
    // Use payment_method instead of payment_mode:
    payment_method: '',
    discount: '',
  });

  // Fetch prepaid orders
  useEffect(() => {
    const fetchOrders = async () => {
      try {
        const token = localStorage.getItem('authToken');
        const response = await axios.get('https://astrovidhya.in/api/orders/verify', {
          headers: { Authorization: `Bearer ${token}` },
        });
        // Filter orders to include only prepaid ones
     // ✅ Fetch ALL Pending Orders (Prepaid & COD + Discount)
const pendingOrders = response.data.filter(
  (order) => order.approval_status === "Pending"
);
setOrders(pendingOrders);

      } catch (error) {
        console.error('Error fetching orders:', error);
        alert('Failed to load orders. Please try again later.');
      }
    };

    fetchOrders();
  }, []);

  // Fetch staff members
  useEffect(() => {
    let isMounted = true;
    const fetchStaffMembers = async () => {
      try {
        const authToken = localStorage.getItem('authToken');
        const response = await axios.get('https://astrovidhya.in/api/staff', {
          headers: { Authorization: `Bearer ${authToken}` },
        });
        if (isMounted) {
          setStaffMembers(response.data);
        }
      } catch (error) {
        console.error('Error fetching staff members:', error);
      }
    };

    fetchStaffMembers();
    return () => {
      isMounted = false;
    };
  }, []);

  // Fetch products
  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await axios.get('https://astrovidhya.in/api/products', {
          headers: { Authorization: `Bearer ${localStorage.getItem('authToken')}` },
        });
        setProducts(response.data);
      } catch (error) {
        console.error('Error fetching products:', error);
      }
    };
    fetchProducts();
  }, []);


  const refreshOrdersPanel = async () => {
    try {
      const token = localStorage.getItem('authToken');
      const response = await axios.get('https://astrovidhya.in/api/orders/verify', {
        headers: { Authorization: `Bearer ${token}` },
      });
  
      // ✅ Refresh the orders state without modifying anything else
      setOrders(response.data);
    } catch (error) {
      console.error('❌ Error refreshing orders:', error);
      alert('Failed to refresh orders.');
    }
  };
  

  // Handle order selection
  const handleOrderClick = (order) => {
    const quantity = order.quantity || 0;
  
    // ✅ Ensure products are correctly mapped from the order
    const formattedProducts = Array.isArray(order.products)
      ? order.products.map((p) => {
          const productData = products.find((prod) => prod._id === p.productId?._id);
          return {
            productId: p.productId?._id || "",
            productName: p.productId?.productName || "Unknown Product",
            quantity: p.quantity || 1,
            price: productData?.price || 0, // ✅ Assign price from products list
          };
        })
      : [];
  
    // ✅ Populate formData with selected order details
    setSelectedOrder(order);
    setFormData({
      customer_name: order.customer_name || "",
      order_date: order.order_date?.split("T")[0] || "",
      order_time: order.order_time || "",
      total_amount: order.total_amount || 0,
      original_total_amount: order.original_total_amount || 0,
      approval_status: order.approval_status || "Pending",
      companyName: order.company_name || "",
      shipping_address: order.shipping_address || "",
      assigned_to: order.assigned_to?._id || "",
      courier: order.courier?._id || "",
      pin: order.pin || "",
      mobile: order.mobile || "",
      so: order.so || "",
      village: order.village || "",
      city: order.city || "",
      district: order.district || "",
      state: order.state || "",
      quantity,
      payment_method: order.payment_method || "",
      discount: order.discount || 0,
      products: formattedProducts, // ✅ Assign properly formatted products array
    });
  };
  
  
  // Handle input change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  // Fetch couriers
  useEffect(() => {
    const fetchCouriers = async () => {
      try {
        const authToken = localStorage.getItem('authToken');
        const response = await axios.get('https://astrovidhya.in/api/couriers/active', {
          headers: { Authorization: `Bearer ${authToken}` },
        });
        setCouriers(response.data);
      } catch (error) {
        console.error('Error fetching couriers:', error);
        // Optionally handle errors here
      }
    };
    fetchCouriers();
  }, []);

  // Revised handleRevise function
  const handleRevise = async () => {
    if (!selectedOrder) {
      alert('Please select an order to revise.');
      return;
    }
  
    try {
      // Build the payload with correct types
      const payload = {
        customer_name: formData.customer_name,
        order_date: new Date(formData.order_date), // Ensure date format
        order_time: formData.order_time,
        total_amount: Number(formData.total_amount),
        original_total_amount: Number(formData.original_total_amount),
        discount: Number(formData.discount),
        // Ensure products is an array; if it's a single ID string, wrap it in an array.
        products: Array.isArray(formData.products)
          ? formData.products
          : [formData.products],
        shipping_address: formData.shipping_address,
        assigned_to: formData.assigned_to, // Ensure this matches your backend (should be a staff ID)
        courier: formData.courier,
        pin: formData.pin,
        mobile: formData.mobile,
        so: formData.so,
        village: formData.village,
        city: formData.city,
        district: formData.district,
        state: formData.state,
        quantity: Number(formData.quantity),
        payment_method: formData.payment_method,
      };
  
      await axios.put(
        `https://astrovidhya.in/api/orders/${selectedOrder._id}`,
        payload,
        {
          headers: { Authorization: `Bearer ${localStorage.getItem('authToken')}` },
        }
      );
      alert('Order revised successfully!');
      setSelectedOrder(null);
      // Reset the formData to initial state
      setFormData({
        customer_name: '',
        order_date: '',
        order_time: '',
        total_amount: '',
        original_total_amount: '',
     //   rate: '',
        approval_status: 'Pending',
        companyName: '',
        products: '',
        shipping_address: '',
        assigned_to: '',
        courier: '',
        pin: '',
        mobile: '',
        so: '',
        village: '',
        city: '',
        district: '',
        state: '',
        quantity: 1,
        payment_method: '',
        discount: '',
      });
    } catch (error) {
      console.error('Error revising order:', error);
      alert('Failed to revise order. Please try again.');
    }
  };
  

  const handleReset = () => {
    setFormData({
      customer_name: '',
      order_date: '',
      order_time: '',
      total_amount: '',
      original_total_amount: '',
    //  rate: '',
      approval_status: 'Pending',
      companyName: '',
      products: '',
      shipping_address: '',
      assigned_to: '',
      courier: '',
      pin: '',
      mobile: '',
      so: '',
      village: '',
      city: '',
      district: '',
      state: '',
      quantity: 1,
      payment_method: '',
      discount: '',
    });
  };

//////////////////////////////////////
////Handlers for product field
//////////////////////////////////////////////

const handleProductChange = (index, productId) => {
  const selectedProduct = products.find((p) => p._id === productId);
  if (!selectedProduct) return;

  setFormData((prev) => {
    const updatedProducts = [...prev.products];
    updatedProducts[index] = {
      productId: selectedProduct._id,
      productName: selectedProduct.productName || "",
      quantity: updatedProducts[index]?.quantity || 1,
      price: selectedProduct.price || 0, // ✅ Store price for total calculation
    };

    // ✅ Recalculate total
    const newTotal = updatedProducts.reduce((sum, p) => sum + (p.price * p.quantity), 0);

    return {
      ...prev,
      products: updatedProducts,
      total_amount: newTotal, // ✅ Update total
      net_total: Math.max(newTotal - prev.discount, 0), // ✅ Ensure net total is non-negative
    };
  });
};


const handleQuantityChange = (index, newQuantity) => {
  setFormData((prev) => {
    const updatedProducts = [...prev.products];
    const product = updatedProducts[index];

    if (!product) return prev; // Prevent errors

    product.quantity = Math.max(1, parseInt(newQuantity, 10) || 1); // Prevent zero/negative

    // ✅ Recalculate total amount based on updated product quantities
    const newTotal = updatedProducts.reduce(
      (sum, p) => sum + (p.quantity * (p.price || 0)), // Multiply quantity by price
      0
    );

    return {
      ...prev,
      products: updatedProducts,
      total_amount: newTotal, // ✅ Update total
      net_total: Math.max(newTotal - prev.discount, 0), // ✅ Ensure net total is non-negative
    };
  });
};



const handleAddProduct = () => {
  setFormData((prev) => ({
    ...prev,
    products: [...prev.products, { productId: '', productName: '', quantity: 1, price: 0 }],
  }));
};

const handleRemoveProduct = (index) => {
  setFormData((prev) => ({
    ...prev,
    products: prev.products.filter((_, i) => i !== index),
  }));
};

/////////more code////////////////////////

// ----------------------
// USEEFFECT - whenever products or discount change
// ----------------------
useEffect(() => {
  const calculateTotalAmount = (productsList, discount) => {
    if (!productsList || productsList.length === 0) {
      setFormData((prev) => ({ ...prev, total_amount: 0 }));
      return;
    }
    const subtotal = productsList.reduce((sum, p) => {
      const price = p.price || 0;
      const qty = p.quantity || 1;
      return sum + price * qty;
    }, 0);

    setFormData((prev) => ({
      ...prev,
      total_amount: subtotal, // ✅ Correct total amount calculation
      net_total: Math.max(subtotal - (discount || 0), 0), // ✅ Ensure net total is correct
    }));
  };

  calculateTotalAmount(formData.products, formData.discount);
}, [formData.products, formData.discount]);



///////////////////////////////////////////////////////////////




  const handleSubmit = async (status) => {
    try {
      const url = `https://astrovidhya.in/api/orders/${selectedOrder._id}/approval`;
      const token = localStorage.getItem('authToken');
  
      await axios.put(
        url,
        { approval_status: status },
        { headers: { Authorization: `Bearer ${token}` } }
      );
  
      alert(`Order ${status.toLowerCase()} successfully!`);
      setSelectedOrder(null);
      setFormData({
        customer_name: '',
        order_date: '',
        order_time: '',
        total_amount: '',
      //  rate: '',
        approval_status: 'Pending',
        companyName: '',
     //   products: '',
        shipping_address: '',
        assigned_to: '',
        courier: '',
        pin: '',
        mobile: '',
        so: '',
        village: '',
        city: '',
        district: '',
        state: '',
      //  quantity: '',
        payment_method: '',
        discount: '',
        original_total_amount: '',
      });
    } catch (error) {
      console.error(`Error ${status.toLowerCase()}ing order:`, error);
      alert('Failed to update order status. Please try again.');
    }
  };

  return (
    <div className="flex p-6 gap-4">
      {/* Form Section */}
      <div className="w-1/3 p-4 bg-white shadow-md rounded-md">
        <h2 className="text-xl font-bold mb-4">Order Form</h2>
        <form className="grid gap-2">
          {/* Customer's Name */}
          <div className="flex gap-4 items-center">
            <label className="w-1/3 text-gray-700">Customer's Name</label>
            <input
              type="text"
              name="customer_name"
              value={formData.customer_name}
              onChange={handleChange}
              className="flex-1 px-3 py-2 border rounded-md focus:outline-none"
            />
          </div>

          {/* Order Date */}
          <div className="flex gap-4 items-center">
            <label className="w-1/3 text-gray-700">Order Date</label>
            <input
              type="date"
              name="order_date"
              value={formData.order_date}
              onChange={handleChange}
              className="flex-1 px-3 py-2 border rounded-md focus:outline-none"
            />
          </div>

          {/* Mobile */}
          <div className="flex gap-4 items-center">
            <label className="w-1/3 text-gray-700">Mobile</label>
            <input
              type="text"
              name="mobile"
              value={formData.mobile}
              onChange={handleChange}
              className="flex-1 px-3 py-2 border rounded-md focus:outline-none"
            />
          </div>

          {/* Pincode */}
          <div className="flex gap-4 items-center">
            <label className="w-1/3 text-gray-700">Pincode</label>
            <input
              type="text"
              name="pin"
              value={formData.pin}
              onChange={handleChange}
              className="flex-1 px-3 py-2 border rounded-md focus:outline-none"
            />
          </div>

          {/* Courier */}
          <div className="flex gap-4 items-center">
            <label className="w-1/3 text-gray-700">Courier</label>
            <select
              name="courier"
              value={formData.courier}
              onChange={handleChange}
              className="flex-1 px-3 py-2 border rounded-md"
            >
              <option value="">Select Courier</option>
              {couriers.map((courier) => (
                <option key={courier._id} value={courier._id}>
                  {courier.name}
                </option>
              ))}
            </select>
          </div>

   {/* PRODUCTS */}
<h3 className="mt-3 font-bold">Products</h3>

{/* Ensure products array exists */}
{(Array.isArray(formData.products) ? formData.products : []).map((item, index) => (
  <div key={index} className="flex items-center w-full gap-3">
    {/* Product Selector */}
    <select
      value={item.productId || ""}
      onChange={(e) => handleProductChange(index, e.target.value)}
      className="flex-1 px-3 py-2 border rounded-md h-10 focus:outline-none focus:ring-1 focus:ring-blue-400"
      required
    >
      <option value="">Select Product</option>
      {products.map((prod) => (
        <option key={prod._id} value={prod._id}>
          {prod.productName}
        </option>
      ))}
    </select>

    {/* Quantity Field */}
    <input
  type="number"
  value={item.quantity}
  onChange={(e) => handleQuantityChange(index, e.target.value)}
  min="1"
  className="w-24 h-10 px-3 mt-3 border rounded-md text-center focus:outline-none focus:ring-1 focus:ring-blue-400"
  required
/>


    {/* Remove Button */}
    <button
      type="button"
      onClick={() => handleRemoveProduct(index)}
      className="w-24 h-10 px-3 bg-red-500 text-white rounded-md hover:bg-red-600 transition"
    >
      Remove
    </button>
  </div>
))}

{/* Add More Products Button */}
<button
  type="button"
  onClick={handleAddProduct}
  className="w-full mt-2 px-3 py-2 text-white rounded-md"
  style={{ backgroundColor: '#03c9d7' }}
>
  + Add More Products
</button>



          {/* Address */}
          <div className="flex gap-4 items-center">
            <label className="w-1/3 text-gray-700">Address</label>
            <input
              type="text"
              name="shipping_address"
              value={formData.shipping_address}
              onChange={handleChange}
              className="flex-1 px-3 py-2 border rounded-md focus:outline-none"
            />
          </div>

          {/* Village */}
          <div className="flex gap-4 items-center">
            <label className="w-1/3 text-gray-700">Village</label>
            <input
              type="text"
              name="village"
              value={formData.village}
              onChange={handleChange}
              className="flex-1 px-3 py-2 border rounded-md focus:outline-none"
            />
          </div>

          {/* Taluka (Using city field) */}
          <div className="flex gap-4 items-center">
            <label className="w-1/3 text-gray-700">Taluka</label>
            <input
              type="text"
              name="city"
              value={formData.city}
              onChange={handleChange}
              className="flex-1 px-3 py-2 border rounded-md focus:outline-none"
            />
          </div>

          {/* District */}
          <div className="flex gap-4 items-center">
            <label className="w-1/3 text-gray-700">District</label>
            <input
              type="text"
              name="district"
              value={formData.district}
              onChange={handleChange}
              className="flex-1 px-3 py-2 border rounded-md focus:outline-none"
            />
          </div>

          {/* State */}
          <div className="flex gap-4 items-center">
            <label className="w-1/3 text-gray-700">State</label>
            <input
              type="text"
              name="state"
              value={formData.state}
              onChange={handleChange}
              className="flex-1 px-3 py-2 border rounded-md focus:outline-none"
            />
          </div>

          {/* Company Field */}
          <div className="flex gap-4 items-center">
            <label className="w-1/3 text-gray-700">Company</label>
            <input
              type="text"
              name="companyName"
              value={formData.companyName}
              onChange={(e) => setFormData({ ...formData, companyName: e.target.value })}
              className="flex-1 px-3 py-2 border rounded-md focus:outline-none"
              placeholder="Enter company name"
            />
          </div>

          {/* Caller (Mapped to assigned_to) */}
          <div className="flex gap-4 items-center">
            <label className="w-1/3 text-gray-700">Caller</label>
            <select
              name="assigned_to"
              value={formData.assigned_to}
              onChange={handleChange}
              className="flex-1 px-3 py-2 border rounded-md"
            >
              <option value="">Select Caller</option>
              {staffMembers.map((staff) => (
                <option key={staff._id} value={staff._id}>
                  {staff.name} ({staff.role})
                </option>
              ))}
            </select>
          </div>

          {/* Payment Method Dropdown */}
          <div className="flex gap-4 items-center">
            <label className="w-1/3 text-gray-700">Payment Method</label>
            <select
              name="payment_method"
              value={formData.payment_method}
              onChange={(e) => setFormData({ ...formData, payment_method: e.target.value })}
              className="flex-1 px-3 py-2 border rounded-md"
            >
              <option value="">Select Payment Method</option>
              {['Prepaid', 'COD'].map((method) => (
                <option key={method} value={method}>
                  {method}
                </option>
              ))}
            </select>
          </div>

          {/* Read-only Status */}
          <div className="flex gap-4 items-center">
            <label className="w-1/3 text-gray-700">Status</label>
            <input
              type="text"
              name="approval_status"
              value={formData.approval_status}
              readOnly
              className="flex-1 px-3 py-2 border rounded-md bg-gray-100"
            />
          </div>

          {/* Rate 
          <div className="flex gap-4 items-center">
            <label className="w-1/3 text-gray-700">Rate (₹)</label>
            <input
              type="number"
              name="rate"
              value={formData.rate}
              readOnly
              className="flex-1 px-3 py-2 border rounded-md bg-gray-100"
            />
          </div>*/}

          {/* Quantity 
          <div className="flex gap-4 items-center">
            <label className="w-1/3 text-gray-700">Quantity</label>
            <input
              type="number"
              name="quantity"
              value={formData.quantity}
              onChange={(e) => {
                const quantity = parseInt(e.target.value, 10) || 0;
                const total = quantity * formData.original_total_amount;
                const netTotal = total - (formData.discount || 0);
                setFormData((prev) => ({
                  ...prev,
                  quantity,
                  total_amount: total,
                  net_total: netTotal > 0 ? netTotal : 0,
                }));
              }}
              className="flex-1 px-3 py-2 border rounded-md focus:outline-none"
            />
          </div>*/}

          {/* Total */}
          <div className="flex gap-4 items-center">
  <label className="w-1/3 text-gray-700">Total (₹)</label>
  <input
    type="number"
    name="total_amount"
    value={formData.total_amount}
    readOnly
    className="flex-1 px-3 py-2 border rounded-md bg-gray-100"
  />
</div>


          {/* Discount */}
          <div className="flex gap-4 items-center">
            <label className="w-1/3 text-gray-700">Discount (₹)</label>
            <input
              type="number"
              name="discount"
              value={formData.discount}
              onChange={(e) => {
                const discount = Math.min(parseInt(e.target.value, 10) || 0, 200);
                const netTotal = formData.original_total_amount - discount;
                setFormData((prev) => ({
                  ...prev,
                  discount,
                  net_total: netTotal > 0 ? netTotal : 0,
                }));
              }}
              className="flex-1 px-3 py-2 border rounded-md focus:outline-none"
            />
          </div>

          {/* Net Total */}
          <div className="flex gap-4 items-center">
            <label className="w-1/3 text-gray-700">Net Total (₹)</label>
            <input
              type="number"
              name="net_total"
              value={formData.total_amount - formData.discount}
              readOnly
              className="flex-1 px-3 py-2 border rounded-md bg-gray-100"
            />
          </div>
        </form>

        <div className="flex gap-4 mt-6">
          <button
            onClick={() => {
              handleSubmit('Approved');
              refreshOrdersPanel(); // ✅ Refresh orders after action
            }}
            className="px-4 py-2 bg-green-500 text-white rounded-md w-1/4"
          >
            Approve
          </button>
          <button
           onClick={() => {
            handleSubmit('Rejected');
            refreshOrdersPanel(); // ✅ Refresh orders after action
          }}
            className="px-4 py-2 bg-red-500 text-white rounded-md w-1/4"
          >
            Reject
          </button>
          <button
           onClick={() => {
            handleRevise();
            refreshOrdersPanel(); // ✅ Refresh orders after action
          }}
            className="px-4 py-2 bg-yellow-500 text-white rounded-md w-1/4"
          >
            Revise
          </button>
          <button
            onClick={handleReset}
            className="px-4 py-2 bg-gray-500 text-white rounded-md w-1/4"
          >
            Reset
          </button>
        </div>
      </div>

      {/* Orders Table */}
      <div className="w-2/3 p-4 bg-white shadow-md rounded-md">
        <h2 className="text-xl font-bold mb-4">Previous Orders</h2>
        <div className="overflow-y-auto" style={{ maxHeight: '50vh' }}>
          <table className="table-auto w-full border border-gray-300">
            <thead className="bg-gray-200">
              <tr>
                <th className="px-4 py-2 border">Select</th>
              {/*  <th className="px-4 py-2 border">Order ID</th> */}
                <th className="px-4 py-2 border">Customer</th>
                <th className="px-4 py-2 border">Status</th>
                <th className="px-4 py-2 border">Date</th>
                <th className="px-4 py-2 border">Courier</th>
                <th className="px-4 py-2 border">Docket No</th>
                <th className="px-4 py-2 border">Product Name</th>
                <th className="px-4 py-2 border">Net Amount</th>
              </tr>
            </thead>
            <tbody>
              {orders.map((order) => (
                <tr
                  key={order._id}
                  className={`cursor-pointer hover:bg-gray-100 ${selectedOrder && selectedOrder._id === order._id ? 'bg-blue-100' : ''}`}
                  onClick={() => handleOrderClick(order)}
                >
                  <td className="px-4 py-2 border">
                    <input
                      type="radio"
                      name="order"
                      checked={selectedOrder && selectedOrder._id === order._id}
                      readOnly
                    />
                  </td>
                {/*  <td className="px-4 py-2 border">{order._id}</td> */}
                  <td className="px-4 py-2 border">{order.customer_name || 'N/A'}</td>
                  <td className="px-4 py-2 border">{order.approval_status || 'Pending'}</td>
                  <td className="px-4 py-2 border">
                    {order.order_date
                      ? new Date(order.order_date).toLocaleDateString('en-US', {
                          year: 'numeric',
                          month: 'short',
                          day: 'numeric',
                        })
                      : 'N/A'}
                  </td>
                  <td className="px-4 py-2 border">
  {order.courier?.name || 'No Courier Assigned'}
</td>

                  <td className="px-4 py-2 border">{order.docket_no || 'N/A'}</td>
                  <td className="px-4 py-2 border">
                    {Array.isArray(order.products) && order.products.length > 0
                      ? order.products.map((p) => p.productName).join(', ')
                      : 'No Products'}
                  </td>
                  <td className="px-4 py-2 border">₹{order.total_amount || 0}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Order Details Panel */}
        <div className="w-full p-4 bg-white shadow-md rounded-md mt-6">
          <h2 className="text-xl font-bold mb-4">Order Details</h2>
          <table className="table-auto w-full border border-gray-300">
            <thead className="bg-gray-200">
              <tr>
                <th className="px-4 py-2 border">Order No</th>
                <th className="px-4 py-2 border">Executive Name</th>
              {/*  <th className="px-4 py-2 border">Action</th>  */}
              </tr>
            </thead>
            <tbody>
              {selectedOrder ? (
                <tr>
                <td className="px-4 py-2 border">
  {selectedOrder._id ? String(selectedOrder._id).toUpperCase() : ''}
</td>

                  <td className="px-4 py-2 border">
                    {
                      staffMembers.find((staff) => staff._id === formData.assigned_to)?.name ||
                      'Not Assigned'
                    }
                  </td>
                {/*  <td className="px-4 py-2 border"></td>  */}
                </tr>
              ) : (
                <tr>
                  <td className="px-4 py-2 border text-center" colSpan="3">
                    No order selected
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default LetsSee;
